import { CityMultiLingualDTO } from "@baloise-cfa/tsclient/addr";

export const getCityName = (propertyCity?: CityMultiLingualDTO): string => {
    if (!propertyCity?.names) return "";

    const names = propertyCity.names;

    if (!names.NLD && !names.FRA) return "";

    if (process.env.GATSBY_CURRENT_LANGUAGE === "nl") {
        return (names.NLD ? names.NLD : names.FRA) as string;
    }

    if (process.env.GATSBY_CURRENT_LANGUAGE === "fr") {
        return (names.FRA ? names.FRA : names.NLD) as string;
    }

    return "";
};
